import React from 'react';

import { validate } from 'validate.js';
import { Row, Col, Modal, Button, Form, Input, Upload } from 'antd';
import { _success, _setAxios, _validationFormMsg, _getFile, _beforeUploadImage } from '../../../../../lib/Helper';
import { InboxOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import SelectTenagaPendidik from '../../../../../components/select/SelectTenagaPendidik';

dayjs.extend(customParseFormat);

const { Dragger } = Upload;

const schema = {
    tenaga_pendidik: {
        presence: { allowEmpty: false, message: 'wajib diisi' },
    },
    jabatan: {
        presence: { allowEmpty: false, message: 'wajib diisi' },
    },
};

class ModalContent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false,
            fileList: [],
            validateFile: false,
            ddl: {
                tk: []
            }
        };
    }

    componentDidMount() {
        this.setState({
            values: {...this.props.data, tenaga_pendidik: this.props.data.tk_id},
        })

        this.getGTKDDL()
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    handleChangeFile = ({ fileList }) => {
        if (this.state.validateFile === true) {
            fileList.forEach((row, i) => {
                fileList[i].status = "done"
            });

            this.setState({
                fileList: fileList
            })
        } else {
            this.setState({
                fileList: []
            })
        }
    };

    beforeUploadFile = (file) => {
        if (!_beforeUploadImage(file)) {
            this.setState({
                validateFile: false,
            })
            return false
        } else {
            this.setState({
                validateFile: true,
            })
        }
        return true
    };

    setForm = (values, name, value) => {
        values[name] = value;
        const errors = validate(values, schema);

        this.setState({
            values: values,
            errors: errors || {},
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    handleSubmit = async () => {
        const { values } = this.state
        const errors = validate(values, schema);
        if (errors) {
            _validationFormMsg(errors)
            return
        }

        this.setState({
            loading: true
        });
        const params = {
            struktur_organisasi_id: this.props.strukturalID,
            tk_id: values.tenaga_pendidik ? values.tenaga_pendidik : null,
            jabatan: values.jabatan ? values.jabatan : null,
            file: await _getFile(this.state.fileList),
        }

        let endpoint = "lembaga/struktur-organisasi/anggota"
        let method = "POST"
        if (values.id) {
            endpoint = "lembaga/struktur-organisasi/anggota/" + values.id
            method = "PUT"
        }

        _setAxios(endpoint, method, params).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.props.fetchTable(true)
                this.props.hideModal()

                this.setState({
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };

    getGTKDDL = () => {
        _setAxios("tk/dropdown/all", "GET").then(resp => {
            if (resp.status === true) {
                this.setState({
                    ddl: {
                        ...this.state.ddl,
                        tk: resp.data.data
                    },
                })
            }
        })
    }

    render() {

        const { values } = this.state
        return (
            <Modal
                maskClosable={false}
                keyboard={false}
                title={"Form Anggota Struktural"}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                closable={false}
                footer={<>
                    <Button onClick={this.props.hideModal}>Batal</Button>
                    <Button type="primary" htmlType="submit" onClick={this.handleSubmit} loading={this.state.loading}>Simpan</Button>
                </>}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                >
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24}>
                            <Form.Item label="Tenaga Pendidik *">
                                <SelectTenagaPendidik
                                    value={values?.tenaga_pendidik ? values.tenaga_pendidik : null}
                                    onChange={(val) => {
                                        this.handleChangeSetValue("tenaga_pendidik", val ? val : null)

                                    }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24}>
                            <Form.Item label="Jabatan *">
                                <Input placeholder="Jabatan"
                                    value={values.jabatan}
                                    onChange={(e) => {
                                        this.handleChangeSetValue("jabatan", e.target.value)
                                    }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24}>
                            <Form.Item label="File">
                                <Dragger
                                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    maxCount={1}
                                    fileList={this.state.fileList}
                                    onChange={this.handleChangeFile}
                                    beforeUpload={this.beforeUploadFile}
                                >
                                    <p className="ant-upload-drag-icon">
                                        <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text">Klik atau seret file ke area ini</p>
                                    <p className="ant-upload-hint">File yang diperbolehkan untuk diunggah: JPG, JPEG & PNG</p>
                                    <p className="ant-upload-hint">File yang diperbolehkan maksimal 2MB</p>
                                </Dragger>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

            </Modal>
        )
    }
}

export default ModalContent;
